// @flow
import * as React from 'react';

type Props = {
  delay?: number,
  children: React.Node
};

type State = {
  pastDelay: boolean
};

export default class RenderWithDelay extends React.PureComponent<Props, State> {
  static defaultProps = {
    delay: 300
  };

  state = {
    pastDelay: false
  };

  timeout: ?TimeoutID;

  componentDidMount() {
    if (this.props.delay === 0) {
      this.setState({ pastDelay: true });
      return;
    }
    this.timeout = setTimeout(() => {
      this.setState({ pastDelay: true });
    }, this.props.delay);
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    if (this.state.pastDelay) {
      return this.props.children;
    }
    return null;
  }
}
